import Button from 'components/Button';
import {
    EmptyMessageDescription, EmptyMessageTitle, EmptyMessageEmoji, EmptyMessageContainer,
} from './styled';

interface Props {
    onClick: () => void;
}

const EmptyApiKey = ({ onClick }: Props) => (
    <EmptyMessageContainer>
        <EmptyMessageEmoji>
            🔒
        </EmptyMessageEmoji>
        <EmptyMessageTitle>
            Create API Keys
        </EmptyMessageTitle>
        <EmptyMessageDescription>
            These keys will allow you to authenticate API requests.
        </EmptyMessageDescription>
        <Button variant="brand" label="Create New API Key" borderRadius="semi-rounded" onClick={onClick} />
    </EmptyMessageContainer>
);

export default EmptyApiKey;
